import { Draggable, DraggableProps } from '@salecycle/experimental/DragAndDrop/Draggable';
import { Button, SvgIcon, Tooltip } from '@salecycle/ui-component-library';
import { PropsWithChildren, useCallback } from 'react';
import styled from 'styled-components';
import { IconKey } from '../SvgIcons/svgIconsParams';

const Container = styled(Draggable)`
  display: flex;
  align-items: center;
  height: 40px;
  width: 100%;
  color: ${({ theme }) => theme.vars.newColor.blue2};
  margin-top: -1px;

  & button {
    height: 40px;
    font-weight: unset;
  }

  & button[disabled] {
    color: ${({ theme }) => theme.designToken.neutral500};
    background-color: ${({ theme }) => theme.designToken.baseWhite};
    border-color: ${({ theme }) => theme.designToken.neutral300};
  }
`;

export interface WorkflowSidebarOptionProps extends DraggableProps, IntrinsicProps {
  icon: IconKey;
  disabled?: boolean;
  onMouseDown?: () => void;
  onMouseUp?: () => void;
  onMouseOver: (e?: unknown) => void;
  onMouseOut: () => void;
  disabledTooltip?: string;
}

export const WorkflowSidebarButton = ({
  dragId,
  onDrop,
  icon,
  disabled,
  disabledTooltip,
  children,
  onMouseDown,
  onMouseUp,
  ...props
}: PropsWithChildren<WorkflowSidebarOptionProps>) => {
  const onDropCallback = useCallback(
    (id: string) => {
      window.focus();
      onDrop(id);
    },
    [onDrop],
  );

  if (disabled && disabledTooltip) {
    return (
      <Container dragId={dragId} onDrop={onDropCallback} {...props} onDrag={undefined}>
        {/* The tooltip should be 8px away from source element, but we need to double it in order to achieve this. */}
        <Tooltip title={disabledTooltip} wrapperStyle={{ width: '100%' }} distance={16}>
          <Button
            variation="workflowSidebarButton"
            leftSideIcon={<SvgIcon name={icon} />}
            fullWidth
            onClick={(e: React.MouseEvent<HTMLElement>) => ({})}
            style={{ justifyContent: 'flex-start' }}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            disabled={disabled}
          >
            {children}
          </Button>
        </Tooltip>
      </Container>
    );
  }

  return (
    <Container dragId={dragId} onDrop={onDropCallback} {...props}>
      <Button
        variation="workflowSidebarButton"
        leftSideIcon={<SvgIcon name={icon} />}
        fullWidth
        onClick={(e: React.MouseEvent<HTMLElement>) => ({})}
        style={{ justifyContent: 'flex-start' }}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        disabled={disabled}
      >
        {children}
      </Button>
    </Container>
  );
};
